<template>
  <div class="related">
    <div class="main">
      <div class="selector">
        {{ $t('assist.relatedTopics') }}（{{ similarSentenceList.length }}）
      </div>
      <div v-if="similarSentenceList.length > 0"></div>
      <div
        v-for="(item, index) in similarSentenceList"
        :key="index"
        class="topic-item"
      >
        <Credible :credibilityValue="item.credibilityValue" />
        <div class="topic-name">
          <span
            class="topic-sentence"
            @click="goDetail(item.topicSentenceId)"
            >{{ item.topicSentence }}</span
          >
          <span v-if="paperId == item.paperId" class="topic-caption">{{
            $t('assist.sameSource')
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { similarSentenceInfo } from '@/api/assist'
import Credible from '../list/credible.vue'

export default defineComponent({
  props: {
    similarSentenceList: {
      type: Array as PropType<similarSentenceInfo[]>,
      default: () => [],
    },
    paperId: {
      type: String,
      default: '',
    },
  },
  components: {
    Credible,
  },
  setup() {
    const goDetail = (sentenceId: string) => {
      window.open(`/topicDetail/${sentenceId}`, '_blank')
    }

    return {
      goDetail,
    }
  },
})
</script>

<style lang="less" scoped>
.related {
  .main {
    width: 380px;
    height: 400px;
    margin-left: 100px;
    .selector {
      font-size: 18px;
      font-weight: 600;
      color: #444444;
      border-left: 3px solid #0ca1bd;
      padding-left: 8px;
      margin-left: -15px;
    }
    .topic-item {
      padding: 30px 0px;
      border-bottom: 1px solid #e5e5e5;
      .topic-name {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
        .topic-sentence {
          line-height: 22px;
          cursor: pointer;
        }
        .topic-caption {
          font-weight: 500;
          font-size: 11px;
          color: #9c9fa6;
          border: 1px solid #9c9fa6;
          border-radius: 5px;
          padding: 2px 3px;
          height: 18px;
          line-height: 11px;
          margin-left: 5px;
          display: inline-block;
        }
      }
    }
  }
}
.mobile-viewport {
  .main {
    margin-left: 10px;
  }
  .related .main {
    width: 95%;
  }
  .related .main .selector {
    font-size: 17px;
  }
}
</style>

